import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  currentSlide: 0,
  peekSlide: 0,
  totalSlides: 0,
};

export const slideSlice = createSlice({
  name: "slides",
  initialState,
  reducers: {
    incrementCurrentSlide: (state) => {
      state.currentSlide += 1;
    },
    decrementCurrentSlide: (state) => {
      state.currentSlide -= 1;
    },
    incrementPeekSlide: (state) => {
      state.peekSlide += 1;
    },
    setCurrentSlide: (state, action) => {
      state.currentSlide = action.payload;
    },
    setPeekSlide: (state, action) => {
      state.peekSlide = action.payload;
    },
    setTotalSlides: (state, action) => {
      state.totalSlides = action.payload;
    },
  },
});

export const {
  incrementCurrentSlide,
  decrementCurrentSlide,
  incrementPeekSlide,
  setCurrentSlide,
  setPeekSlide,
  setTotalSlides,
} = slideSlice.actions;

export default slideSlice.reducer;
